import { useEffect, type RefObject } from 'react'
import type { Group } from 'three'

// undefined key = locomotive
const registry = new Map<string, RefObject<Group | null>>()

export function registerVehicleRef(id: string, ref: RefObject<Group | null>) {
  registry.set(id, ref)
}

export function unregisterVehicleRef(id: string) {
  registry.delete(id)
}

export function getVehicleRef(id: string): RefObject<Group | null> | undefined {
  return registry.get(id)
}

export function getAllVehicleRefs(): Map<string, RefObject<Group | null>> {
  return registry
}

export function useVehicleKinematics(ref: RefObject<Group | null>, wagonId: string) {
  useEffect(() => {
    registerVehicleRef(wagonId, ref)
    return () => unregisterVehicleRef(wagonId)
  }, [wagonId, ref])
}
